import ApiaField from '../ApiaField';
import Field from '../constants/Field';
import ApiaForm from '../ApiaForm';
import { IApiaField } from '../types';

export type TEditorField = IApiaField;

export default class EditorField extends ApiaField implements TEditorField {
  constructor(field: HTMLDivElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_INPUT_AS_TEXT,
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_MODAL_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_VISIBILITY_HIDDEN,
      Field.PROPERTY_STORE_MODAL_QUERY_RESULT,
      Field.PROPERTY_TRANSLATION_REQUIRED,
      Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
    ]);
  }
}
